import React, { useEffect, useContext, useState } from 'react';
import { AuthContextApi } from '../../../Context/api';
import { AuthContext } from '../../../Context';
import { useParams, useNavigate } from 'react-router-dom';
import SpinnerOverlay from '../../../Components/SpinnerOverlay';
import { MagnifyingGlassIcon, DocumentTextIcon, PhotoIcon, FolderOpenIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import NavBar from '../../../Components/NavBar';

const truncate = (str, n) => (str && str.length > n ? str.substr(0, n - 1) + '…' : str);

const FolderView = (props) => {


    /*
    
    const [subFoldersData, setSubFoldersData] = useState([])
    const [filesData, setFilesData] = useState([])
    const [offsetSubfoldersAndFiles, setOffsetSubfoldersAndFiles] = useState(0)
    const [limitSubfoldersAndFiles, setLimitSubfoldersAndFiles] = useState(jsonConfig.limitSearch)
    const [limitSearchSubfoldersAndFiles, setLimitSearchSubfoldersAndFiles] = useState(false)
    const [haveMoreSubfoldersAndFiles, setHaveMoreSubfoldersAndFiles] = useState(true)
    */

    const { onOpenFile, onBack } = props;
    const { getFoldersAuthorizade } = useContext(AuthContextApi);
    const { states, setters } = useContext(AuthContext);
    const { folder_id } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [hasData, setHasData] = useState(false);


    const fetchData = async () => {
        setters.setIsLoading(true);
        await getFoldersAuthorizade(folder_id);
    };

    useEffect(() => {
        setError(null);
        if (folder_id) fetchData();
        return () => {
            setters.setSubFoldersData([]);
            setters.setFilesData([]);
            setters.setOffsetSubfoldersAndFiles(0);
            setters.setLimitSearchSubfoldersAndFiles(false);
            setters.setPastasCompartilhadas({});
            setters.setIsLoading(false);
        };
    }, [folder_id]);


    useEffect(() => {
        if (states.subFoldersData?.length > 0 || states.filesData.files?.length > 0) {
            fetchData();
        }
    }, [states.offsetSubfoldersAndFiles]);



    const folder = states.PastasCompartilhadas;
    // Modelo correto: folder.files e folder.subFolders

    // const hasData = states.PastasCompartilhadas && states.PastasCompartilhadas.data && (Array.isArray(states.PastasCompartilhadas.data.files) || Array.isArray(states.PastasCompartilhadas.data.subFolders));

    // Garante que onOpenFile é uma função
    const safeOnOpenFile = typeof onOpenFile === 'function' ? onOpenFile : () => { console.log('onOpenFile não é função!') };

    return (
        <>
            <div className="flex flex-1 flex-col  mb-4 mt-2">
                {/* Botão de voltar sempre visível */}
                <div className="p-4">
                    <div className="px-4 sm:px-6 lg:px-8 flex items-center gap-4">
                        <button
                            className="flex items-center gap-1 px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm font-semibold shadow"
                            onClick={() => onBack ? onBack() : navigate('/pastasCompartilhadas')}
                        >
                            <ArrowLeftIcon className="h-5 w-5" /> Voltar
                        </button>
                        <h1 className="text-[30px] text-base font-semibold leading-6 text-gray-900">Arquivos</h1>
                    </div>
                </div>
                {states.isLoading && (
                    <div className="fixed inset-0 bg-white bg-opacity-60 flex items-center justify-center z-50">
                        <div className="text-blue-600 text-lg font-semibold animate-pulse">Carregando...</div>
                    </div>
                )}
                {error && (
                    <div className="flex flex-col items-center justify-center h-96">
                        <div className="text-red-500 text-lg font-bold mb-2">{error}</div>
                        <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded" onClick={() => window.location.reload()}>Tentar novamente</button>
                        <pre className="text-xs text-gray-400 mt-4 max-w-xl overflow-x-auto bg-gray-100 p-2 rounded">{JSON.stringify(folder, null, 2)}</pre>
                    </div>
                )}
            </div>
            <div className="mt-8 ml-2">
                <div className="bg-gradient-to-r from-blue-500 to-indigo-600  shadow-lg p-6 mb-6 text-white flex items-center gap-4">
                    <div className="flex-shrink-0 bg-white bg-opacity-20 rounded-full p-2">
                        <FolderOpenIcon className="h-10 w-10 text-white" />
                    </div>
                    <div>
                        <h2 className="text-2xl font-bold mb-1 flex items-center gap-2">{states.PastasCompartilhadas?.title}</h2>
                        <p className="mb-1 text-sm opacity-90">{truncate(states.PastasCompartilhadas?.description, 80)}</p>
                        <span className="text-xs opacity-80">{states.PastasCompartilhadas?.authorizationTitle}</span>
                    </div>
                </div>
                {/* Subpastas */}
                <div className="mb-8">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2">Subpastas</h3>
                    {states.subFoldersData.length === 0 ? (
                        <div className="text-gray-400 text-sm">Nenhuma subpasta encontrada.</div>
                    ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                            {states.subFoldersData?.map(subFolder => (
                                <div
                                    key={subFolder.id}
                                    className="bg-gradient-to-r from-indigo-100 to-blue-200 rounded-xl shadow-md p-4 flex flex-col justify-between hover:shadow-xl transition cursor-pointer border border-blue-200 min-h-[100px] group"
                                    onClick={() => navigate(`/pastasCompartilhadas/${subFolder.id}`)}
                                    title={`Entrar em ${subFolder.name}`}
                                >
                                    <div className="flex items-center gap-2 mb-2">
                                        <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-blue-200 group-hover:bg-blue-400 transition">
                                            <FolderOpenIcon className="h-5 w-5 text-blue-600 group-hover:text-white" />
                                        </span>
                                        <h4 className="font-semibold text-base text-gray-800 truncate" title={subFolder.name}>{truncate(subFolder.name, 28)}</h4>
                                    </div>
                                    <p className="text-xs text-gray-500 mb-1 truncate" title={subFolder.description}>{truncate(subFolder.description, 32)}</p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                {/* Arquivos */}
                <h3 className="text-lg font-semibold text-gray-700 mb-2">Arquivos</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {states.filesData?.length === 0 ? (
                        <div className="col-span-full text-center text-gray-500">Nenhum arquivo encontrado.</div>
                    ) : (
                        states.filesData?.map(file => {
                            const isPDF = file.file_name?.toLowerCase().endsWith('.pdf');
                            return (
                                <div key={file.id} className="bg-white rounded-xl shadow-md p-6 flex flex-col justify-between hover:shadow-xl transition cursor-pointer border border-blue-200 min-h-[160px]">
                                    <div className="flex items-center gap-2 mb-2">
                                        <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-blue-100">
                                            {isPDF ? <DocumentTextIcon className="h-5 w-5 text-blue-600" /> : <PhotoIcon className="h-5 w-5 text-indigo-600" />}
                                        </span>
                                        <h3 className="font-semibold text-base text-gray-800 truncate" title={file.title}>{truncate(file.title, 28)}</h3>
                                    </div>
                                    <p className="text-xs text-gray-500 mb-1 truncate" title={file.file_name}>{truncate(file.file_name, 32)}</p>
                                    <span className="text-xs text-gray-400 mb-1">Enviado por: {truncate(file.user_email, 22)}</span>
                                    <span className="text-xs text-gray-300">{new Date(file.created_at).toLocaleDateString()}</span>
                                    <div className="mt-4 flex justify-end">
                                        <button className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-xs font-semibold shadow flex items-center gap-1" title="Abrir arquivo" onClick={() => { safeOnOpenFile(file.id); }}>
                                            Visualizar
                                        </button>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
                {/* Paginação */}
                <div className="flex justify-center mt-8 gap-2">
                    <button
                        className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 disabled:opacity-50"
                        disabled={states.offsetSubfoldersAndFiles === 0}
                        onClick={() => setters.setOffsetSubfoldersAndFiles(Math.max(0, states.offsetSubfoldersAndFiles - states.limitSubfoldersAndFiles))}
                        title="Página anterior"
                    >Anterior</button>
                    <button
                        className="px-4 py-2 rounded bg-blue-500 hover:bg-blue-600 text-white disabled:opacity-50"
                        disabled={!states.haveMoreSubfoldersAndFiles}
                        onClick={() => setters.setOffsetSubfoldersAndFiles(states.offsetSubfoldersAndFiles + states.limitSubfoldersAndFiles)}
                        title="Próxima página"
                    >Próxima</button>
                </div>
            </div>
        </>
    );
};

export default FolderView; 